import React from 'react';
import PropTypes from 'prop-types';

import Contacts from '../AreaDetails/Contacts';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

const ContactsTable = ({
  overview: { details },
}) => (
  <div>
    <div className="property-images" />
    <section>
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">Contacts</h4>
      </ViewerPrimaryColorUserStyle>
      <Contacts contacts={details.contacts} />
    </section>
  </div>
);

ContactsTable.propTypes = {
  overview: PropTypes.object,
};

export default ContactsTable;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/ContactsTable.js